module.exports = __webpack_public_path__ + "static/9e616fb95ca30a1e89e329a861200717d602ae680060f938ab76b17b960e7672-60583236898c92fa65b684a471f9777c.png";